<footer>
  <p>Copyright {{ year }} - Makit Technology</p>
</footer>